import React, { useEffect, useState } from 'react';
import { MessageSquareIcon, PlusIcon, SearchIcon, TagIcon, UserIcon, MessageCircleIcon, EyeIcon, FilterIcon, PinIcon, XIcon, CheckCircleIcon, BookOpenIcon, HelpCircleIcon, Trash2 } from 'lucide-react';
import TeacherNewTopic from './forum/TeacherNewTopic';
import TeacherTopicDetail from './forum/TeacherTopicDetail';
const TeacherForum = () => {
  const [showNewTopic, setShowNewTopic] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [activeFilter, setActiveFilter] = useState('all');
  const [activeTab, setActiveTab] = useState('soru-cozum'); // 'soru-cozum' or 'diger'
  const [topics, setTopics] = useState([]);
  // Load topics from localStorage
  useEffect(() => {
    const savedTopics = localStorage.getItem('teacherForumTopics');
    if (savedTopics) {
      setTopics(JSON.parse(savedTopics));
    } else {
      // Initial topics if none in localStorage
      const initialTopics = [{
        id: 1,
        title: 'Türev konusunda öğrencilerin zorlandığı noktalar',
        author: 'Öğretmen',
        authorType: 'teacher',
        date: '2 saat önce',
        replies: 8,
        views: 42,
        category: 'Matematik',
        tags: ['Türev', 'Kalkülüs'],
        pinned: true,
        awaitingResponse: false,
        type: 'soru-cozum',
        teacherApproved: true,
        studentSelected: false
      }, {
        id: 2,
        title: 'YKS hazırlık sürecinde öğrencilere nasıl destek olabiliriz?',
        author: 'Öğretmen',
        authorType: 'teacher',
        date: '5 saat önce',
        replies: 12,
        views: 67,
        category: 'Sınavlar',
        tags: ['YKS', 'Rehberlik'],
        pinned: false,
        awaitingResponse: true,
        type: 'diger'
      }, {
        id: 3,
        title: 'Fizik deneyleri için laboratuvar kullanım önerileri',
        author: 'Ali Demir',
        authorType: 'student',
        date: '1 gün önce',
        replies: 15,
        views: 89,
        category: 'Fizik',
        tags: ['Laboratuvar', 'Deneyler'],
        pinned: false,
        awaitingResponse: false,
        type: 'soru-cozum',
        teacherApproved: false,
        studentSelected: true
      }, {
        id: 4,
        title: 'Öğrencilerin dikkat eksikliğiyle başa çıkma yöntemleri',
        author: 'Zeynep Şahin',
        authorType: 'student',
        date: '2 gün önce',
        replies: 20,
        views: 124,
        category: 'Rehberlik',
        tags: ['Dikkat', 'Odaklanma'],
        pinned: false,
        awaitingResponse: true,
        type: 'diger'
      }, {
        id: 5,
        title: 'Kimya dersinde periyodik tablo öğretim teknikleri',
        author: 'Öğretmen',
        authorType: 'teacher',
        date: '3 gün önce',
        replies: 18,
        views: 103,
        category: 'Kimya',
        tags: ['Periyodik Tablo', 'Elementler'],
        pinned: false,
        awaitingResponse: false,
        type: 'soru-cozum',
        teacherApproved: true,
        studentSelected: false
      }, {
        id: 6,
        title: 'Etkili sınıf yönetimi için tavsiyeler',
        author: 'Elif Öztürk',
        authorType: 'student',
        date: '4 gün önce',
        replies: 25,
        views: 156,
        category: 'Genel',
        tags: ['Sınıf Yönetimi', 'Disiplin'],
        pinned: false,
        awaitingResponse: false,
        type: 'diger'
      }, {
        id: 7,
        title: 'Biyoloji konularında görsel materyal kullanımı',
        author: 'Murat Aksoy',
        authorType: 'student',
        date: '5 gün önce',
        replies: 14,
        views: 92,
        category: 'Biyoloji',
        tags: ['Görsel Materyal', 'Öğretim'],
        pinned: false,
        awaitingResponse: true,
        type: 'soru-cozum',
        teacherApproved: false,
        studentSelected: false
      }];
      setTopics(initialTopics);
      localStorage.setItem('teacherForumTopics', JSON.stringify(initialTopics));
    }
  }, []);
  // Save topics to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('teacherForumTopics', JSON.stringify(topics));
  }, [topics]);
  const togglePinTopic = id => {
    setTopics(topics.map(topic => topic.id === id ? {
      ...topic,
      pinned: !topic.pinned
    } : topic));
  };
  const handleSelectTopic = topic => {
    setSelectedTopic(topic);
  };
  const handleBackToList = () => {
    setSelectedTopic(null);
  };
  const handleDeleteTopic = topicId => {
    setTopics(topics.filter(topic => topic.id !== topicId));
    if (selectedTopic?.id === topicId) {
      setSelectedTopic(null);
    }
    // Show toast notification (would need to implement a toast system)
    console.log('Konu başarıyla silindi!');
  };
  const showToast = (message, type) => {
    // Simple console log for now, would implement a proper toast system
    console.log(`Toast: ${message} (${type})`);
  };
  const [personalFilter, setPersonalFilter] = useState('all-topics'); // 'all-topics' or 'my-topics'
  const filteredTopics = topics.filter(topic => {
    // First filter by tab
    if (topic.type !== activeTab) return false;
    // Then apply personal filter
    if (personalFilter === 'my-topics' && topic.author !== 'Öğretmen') return false;
    // Then apply additional filters
    if (activeFilter === 'all') return true;
    if (activeFilter === 'awaiting') return topic.awaitingResponse;
    return topic.category.toLowerCase() === activeFilter.toLowerCase();
  }).sort((a, b) => {
    // Pinned topics always come first
    if (a.pinned && !b.pinned) return -1;
    if (!a.pinned && b.pinned) return 1;
    return 0;
  });
  return <div className="space-y-6 bg-black min-h-screen" data-id="element-2107">
      {selectedTopic ? <TeacherTopicDetail topic={selectedTopic} onBack={handleBackToList} isTeacher={true} onDeleteTopic={handleDeleteTopic} data-id="element-2108" /> : <>
          <div className="flex justify-between items-center" data-id="element-2109">
            <div className="flex items-center" data-id="element-2110">
              <MessageSquareIcon size={24} className="mr-2 text-emerald-400" data-id="element-2111" />
              <h1 className="text-2xl font-bold" data-id="element-2112">Forum</h1>
            </div>
            <button className="bg-emerald-600 hover:bg-emerald-500 text-white px-4 py-2 rounded-md flex items-center transition-colors" onClick={() => setShowNewTopic(true)} data-id="element-2113">
              <PlusIcon size={18} className="mr-2" data-id="element-2114" />
              Yeni Konu
            </button>
          </div>
          {/* Tab Navigation */}
          <div className="flex border-b border-gray-800" data-id="element-2115">
            <button className={`relative py-3 px-6 font-medium text-sm transition-colors ${activeTab === 'soru-cozum' ? 'text-emerald-400' : 'text-gray-400 hover:text-gray-300'}`} onClick={() => setActiveTab('soru-cozum')} data-id="element-2116">
              <div className="flex items-center" data-id="element-2117">
                <HelpCircleIcon size={16} className="mr-2" data-id="element-2118" />
                Soru Çözüm
              </div>
              {activeTab === 'soru-cozum' && <div className="absolute bottom-0 left-0 w-full h-0.5 bg-emerald-500" data-id="element-2119"></div>}
            </button>
            <button className={`relative py-3 px-6 font-medium text-sm transition-colors ${activeTab === 'diger' ? 'text-emerald-400' : 'text-gray-400 hover:text-gray-300'}`} onClick={() => setActiveTab('diger')} data-id="element-2120">
              <div className="flex items-center" data-id="element-2121">
                <MessageCircleIcon size={16} className="mr-2" data-id="element-2122" />
                Diğer
              </div>
              {activeTab === 'diger' && <div className="absolute bottom-0 left-0 w-full h-0.5 bg-emerald-500" data-id="element-2123"></div>}
            </button>
          </div>
          <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-emerald-500" data-id="element-2124">
            <div className="relative p-6 bg-black rounded-lg h-full" data-id="element-2125">
              <div className="flex flex-col md:flex-row md:items-center space-y-4 md:space-y-0 md:space-x-4 mb-6" data-id="element-2126">
                <div className="flex-1 relative" data-id="element-2127">
                  <div className="relative p-[1px] rounded-md overflow-hidden bg-gradient-to-r from-emerald-600/40 to-emerald-500/40" data-id="element-2128">
                    <div className="relative flex items-center" data-id="element-2129">
                      <SearchIcon size={18} className="absolute left-3 text-gray-500" data-id="element-2130" />
                      <input type="text" placeholder={activeTab === 'soru-cozum' ? 'Soru çözümlerde ara...' : 'Konularda ara...'} className="w-full bg-gray-900 rounded-md py-2 pl-10 pr-4 focus:outline-none" data-id="element-2131" />
                    </div>
                  </div>
                </div>
                <div className="flex space-x-2" data-id="element-2132">
                  {activeTab === 'soru-cozum' && <select className="bg-gray-800 hover:bg-gray-700 px-3 py-2 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-emerald-500" onChange={e => setActiveFilter(e.target.value)} value={activeFilter} data-id="element-2133">
                      <option value="all" data-id="element-2134">Tüm Dersler</option>
                      <option value="Matematik" data-id="element-2135">Matematik</option>
                      <option value="Fizik" data-id="element-2136">Fizik</option>
                      <option value="Kimya" data-id="element-2137">Kimya</option>
                      <option value="Biyoloji" data-id="element-2138">Biyoloji</option>
                    </select>}
                  <button className={`px-3 py-2 rounded-md flex items-center ${activeFilter === 'awaiting' ? 'bg-emerald-600/20 text-emerald-400 border border-emerald-500/30' : 'bg-gray-800 hover:bg-gray-700'}`} onClick={() => setActiveFilter(activeFilter === 'awaiting' ? 'all' : 'awaiting')} data-id="element-2139">
                    <MessageCircleIcon size={16} className="mr-2" data-id="element-2140" />
                    Yanıt Bekleyenler
                  </button>
                  <button className={`px-3 py-2 rounded-md flex items-center ${personalFilter === 'my-topics' ? 'bg-emerald-600/20 text-emerald-400 border border-emerald-500/30' : 'bg-gray-800 hover:bg-gray-700'}`} onClick={() => setPersonalFilter(personalFilter === 'my-topics' ? 'all-topics' : 'my-topics')} data-id="element-2141">
                    <UserIcon size={16} className="mr-2" data-id="element-2142" />
                    Konularım
                  </button>
                </div>
              </div>
              {/* Topic List - Different for each tab */}
              <div className="grid grid-cols-1 gap-4" data-id="element-2143">
                {filteredTopics.map(topic => <div key={topic.id} className="relative p-[1px] rounded-md overflow-hidden bg-gradient-to-r from-emerald-600/30 to-emerald-500/30 hover:from-emerald-600/50 hover:to-emerald-500/50 transition-all duration-300" data-id="element-2144">
                    <div className="relative p-4 bg-black rounded-md h-full" data-id="element-2145">
                      <div className="flex justify-between" data-id="element-2146">
                        <div className="flex items-center space-x-2" data-id="element-2147">
                          {activeTab === 'soru-cozum' && <span className="text-xs bg-gray-800 text-emerald-400 px-2 py-1 rounded-full" data-id="element-2148">
                              {topic.category}
                            </span>}
                          {topic.pinned && <span className="text-xs bg-emerald-900/40 text-emerald-400 px-2 py-1 rounded-full flex items-center" data-id="element-2149">
                              <PinIcon size={12} className="mr-1" data-id="element-2150" />
                              Sabitlenmiş
                            </span>}
                          {topic.awaitingResponse && <span className="text-xs bg-amber-900/40 text-amber-400 px-2 py-1 rounded-full" data-id="element-2151">
                              Yanıt Bekliyor
                            </span>}
                        </div>
                        <div className="flex items-center" data-id="element-2152">
                          <span className="text-xs text-gray-400 mr-2" data-id="element-2153">
                            {topic.date}
                          </span>
                          <button className={`p-1.5 rounded-full ${topic.pinned ? 'bg-emerald-600/20 text-emerald-400' : 'bg-gray-800 text-gray-400 hover:text-emerald-400 hover:bg-gray-700'}`} onClick={e => {
                      e.stopPropagation();
                      togglePinTopic(topic.id);
                    }} title={topic.pinned ? 'Sabitlemeyi Kaldır' : 'Sabitle'} data-id="element-2154">
                            <PinIcon size={14} data-id="element-2155" />
                          </button>
                          {/* ÖĞRETMEN EK YETKİLERİ - SİL BUTONU */}
                          <div className="flex items-center gap-2 ml-1" data-id="element-2156">
                            <button onClick={e => {
                        e.stopPropagation();
                        handleDeleteTopic(topic.id);
                      }} className="p-1.5 rounded-full bg-red-500/10 text-red-400 hover:bg-red-500/20 transition-colors" title="Konuyu Sil" data-id="element-2157">
                              <Trash2 size={14} data-id="element-2158" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-start justify-between mt-2" data-id="element-2159">
                        <div data-id="element-2160">
                          <h3 className="font-medium mb-1 cursor-pointer hover:text-emerald-400 transition-colors" onClick={() => handleSelectTopic(topic)} data-id="element-2161">
                            {topic.title}
                          </h3>
                          <div className="flex items-center text-sm text-gray-400" data-id="element-2162">
                            <UserIcon size={14} className="mr-1" data-id="element-2163" />
                            {topic.author}
                            {activeTab === 'soru-cozum' && <>
                                {topic.teacherApproved && <span className="ml-3 flex items-center text-emerald-400" data-id="element-2164">
                                    <CheckCircleIcon size={14} className="mr-1" data-id="element-2165" />
                                    Öğretmen onaylı
                                  </span>}
                                {topic.studentSelected && <span className="ml-3 flex items-center text-emerald-400" data-id="element-2166">
                                    <CheckCircleIcon size={14} className="mr-1" data-id="element-2167" />
                                    Öğrenci seçimi
                                  </span>}
                              </>}
                          </div>
                        </div>
                        {activeTab === 'diger' && <div className="flex items-center text-gray-400" data-id="element-2168">
                            <MessageCircleIcon size={14} className="mr-1" data-id="element-2169" />
                            <span className="text-sm" data-id="element-2170">
                              {topic.replies} yanıt
                            </span>
                          </div>}
                      </div>
                    </div>
                  </div>)}
                {filteredTopics.length === 0 && <div className="text-center py-10 text-gray-400" data-id="element-2171">
                    <div className="flex justify-center mb-3" data-id="element-2172">
                      {activeTab === 'soru-cozum' ? <BookOpenIcon size={32} className="text-gray-600" data-id="element-2173" /> : <MessageCircleIcon size={32} className="text-gray-600" data-id="element-2174" />}
                    </div>
                    <p data-id="element-2175">
                      Henüz {activeTab === 'soru-cozum' ? 'soru çözüm' : 'konu'}{' '}
                      bulunmamaktadır.
                    </p>
                    <button className="mt-3 text-emerald-400 hover:text-emerald-300 font-medium" onClick={() => setShowNewTopic(true)} data-id="element-2176">
                      İlk konuyu oluştur
                    </button>
                  </div>}
              </div>
              {filteredTopics.length > 0 && <div className="mt-6 flex justify-center" data-id="element-2177">
                  <div className="flex space-x-1" data-id="element-2178">
                    <button className="px-3 py-1 bg-emerald-600/20 text-emerald-400 rounded-md" data-id="element-2179">
                      1
                    </button>
                    <button className="px-3 py-1 bg-gray-800 hover:bg-gray-700 rounded-md" data-id="element-2180">
                      2
                    </button>
                    <button className="px-3 py-1 bg-gray-800 hover:bg-gray-700 rounded-md" data-id="element-2181">
                      3
                    </button>
                    <span className="px-3 py-1" data-id="element-2182">...</span>
                    <button className="px-3 py-1 bg-gray-800 hover:bg-gray-700 rounded-md" data-id="element-2183">
                      8
                    </button>
                  </div>
                </div>}
            </div>
          </div>
        </>}
      {/* New Topic Modal */}
      {showNewTopic && <TeacherNewTopic onClose={() => setShowNewTopic(false)} onAddTopic={newTopic => {
      const topicWithId = {
        ...newTopic,
        id: topics.length > 0 ? Math.max(...topics.map(t => t.id)) + 1 : 1,
        author: 'Öğretmen',
        authorType: 'teacher',
        date: 'Az önce',
        replies: 0,
        views: 0,
        pinned: false,
        awaitingResponse: true
      };
      setTopics([topicWithId, ...topics]);
      setShowNewTopic(false);
    }} data-id="element-2184" />}
    </div>;
};
export default TeacherForum;